import { DispatchBoardQueueLoad } from "app/data/city-delivery/dispatch-board/models";
import CityDeliveryDiaptchBoardService from "app/data/city-delivery/dispatch-board/cityDeliveryDiaptchBoardService";
import React, { memo, useState } from "react";
import Button, { ButtonThemes } from "ui-components/button/button";
import { toast } from "react-toastify";
import XGSIcon from "ui-components/icon/xgsIcon";
import XGSIcons from "ui-components/icon/xgsIcons";

export interface CityDeliveryDispatchWorkflowToolsProps {
    dispatchLoad: DispatchBoardQueueLoad;
}

const cityDeliveryDispatchBoardService = CityDeliveryDiaptchBoardService.getInstance();

const CityDeliveryDispatchWorkflowTools: React.FC<CityDeliveryDispatchWorkflowToolsProps> = memo((props) => {
    const { dispatchLoad } = props;
    const [isDownloading, setIsDownloading] = useState(false);

    const hasManifestNumber =
        typeof dispatchLoad?.manifestNumber === "number" && dispatchLoad.manifestNumber !== 0;

    const handleDownloadDriverReceipts = async () => {
        if (!hasManifestNumber) return;
        try {
            setIsDownloading(true);
            const response = await cityDeliveryDispatchBoardService.downloadDriverReceipts({
                manifestNumber: dispatchLoad.manifestNumber,
            });
            const pdfBlob = new Blob([response.data], { type: "application/pdf" });
            const url = window.URL.createObjectURL(pdfBlob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `driver-receipts_${dispatchLoad.manifestNumber}.pdf`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            const msg =
                (error as any)?.getError?.() ??
                (error as any)?.response?.data?.detail ??
                (error as any)?.data?.detail ??
                "Failed to download driver receipts";
            toast.error(msg);
        } finally {
            setIsDownloading(false);
        }
    };

    if (!hasManifestNumber) {
        return null;
    }

    return (
        <div className="city-delivery-dispatch-workflow__tools">
            <Button
                theme={ButtonThemes.blue}
                className="city-delivery-dispatch-workflow__tools__button"
                disabled={isDownloading}
                spinner={isDownloading}
                onClick={handleDownloadDriverReceipts}
            >
                <XGSIcon icon={XGSIcons.faDownload} /> Driver Receipts
            </Button>
        </div>
    );
});

export default CityDeliveryDispatchWorkflowTools;
